export default __webpack_public_path__ + "6609c7dee3ee98595e8f31991026530c.png";